import { useAtom } from "@reatom/npm-react"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"
import { Dispatch, SetStateAction, useEffect } from "react"
import { useToggle } from "react-use"

import {
    findNextQuestion,
    findPrevQuestion,
    findQuestionIndexById,
    sendAnalyticPrevQuestion,
    SurveyAnswer,
    SurveyQuestions,
} from "modules/NewClientSurvey/common"
import { PageWrapper } from "modules/NewClientSurvey/components/PageWrapper"
import { Question } from "modules/NewClientSurvey/components/Question"
import { questionAtom, answersAtom } from "modules/NewClientSurvey/common/models"
import { sendAnswersGetProfiles } from "modules/NewClientSurvey/components/StepTwoQuestions/helpers/sendAnswerGetProfile"
import { Analytics } from "utils/analytics"
import { UserAccount } from "utils/UserAccount"

interface Props {
    surveyQuestions: SurveyQuestions
    slug: string
    prevPage: () => void
    setSlug: Dispatch<SetStateAction<string>>
    cleanSurvey: () => void
}

export function StepTwoQuestions({ prevPage, slug, surveyQuestions, setSlug, cleanSurvey }: Props) {
    const navigate = useNavigate()

    const [question, setQuestion] = useAtom(questionAtom)
    const questionIndex = findQuestionIndexById(surveyQuestions, question?.id)
    const [answers] = useAtom(answersAtom)
    const [surveyStartedSend, toggleSurveyStartedSend] = useToggle(false)

    async function nextPage(answers: Record<string, SurveyAnswer>) {
        const nextQuestion = findNextQuestion(surveyQuestions, question.id, answers)
        if (!nextQuestion) {
            setSlug("")
            Analytics.survey_finished()
            await sendAnswersGetProfiles(answers, surveyQuestions, slug).then((res) => {
                if (res) navigate(res)
                if (UserAccount.email) {
                    toast(
                        `
                            Мы отправили подборку на вашу почту ${UserAccount.email},
                            чтобы вы смогли вернуться к ней в любой момент.
                        `,
                        { delay: 1000 }
                    )
                }
            })

            cleanSurvey()
        } else {
            setQuestion(nextQuestion)
        }
    }

    function previousPage() {
        const prevQuestion = findPrevQuestion(surveyQuestions, question.id, answers)

        sendAnalyticPrevQuestion(question, surveyQuestions.title, prevQuestion)
        if (prevQuestion) {
            setQuestion(prevQuestion)
        } else prevPage()
    }

    useEffect(() => {
        if (Object.keys(question).length === 0) {
            setQuestion(surveyQuestions.questions[0])
        }
    }, [])

    useEffect(() => {
        if (Object.keys(answers).length > 0 && !surveyStartedSend) {
            toggleSurveyStartedSend()
            Analytics.survey_started()
        }
    }, [answers])

    return (
        <PageWrapper
            step={{
                prevPage: previousPage,
                count: surveyQuestions.questions.length,
                active: questionIndex,
                buttonText: "Назад",
            }}
        >
            <Question
                question={question}
                surveyQuestions={surveyQuestions}
                nextPage={nextPage}
                key={question.id}
            />
        </PageWrapper>
    )
}
